export default __webpack_public_path__ + "static/media/e-ppt-logotype-d.a15965e2.svg";